"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnsavedChangesModal = exports.ToggleWithLabel = exports.ManageInstallationButtons = exports.InstallAndUninstallButtons = exports.ActionButtons = void 0;
exports.getErrorMessage = getErrorMessage;

var _preact = require("preact");

var _assets = _interopRequireDefault(require("@insided/deprecated-preact-components/assets"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _Switcher = _interopRequireDefault(require("@insided/deprecated-preact-components/control/Switcher"));

var _reactModal = _interopRequireDefault(require("../../../components/reactModal"));

var _buttonControlSelector = _interopRequireDefault(require("@insided/deprecated-preact-components/button-control-selector"));

function getErrorMessage(inputField, errorFields) {
  var _errorFields$find$mes, _errorFields$find;

  return (_errorFields$find$mes = errorFields === null || errorFields === void 0 ? void 0 : (_errorFields$find = errorFields.find(function (_ref) {
    var field = _ref.field;
    return field === inputField;
  })) === null || _errorFields$find === void 0 ? void 0 : _errorFields$find.message) !== null && _errorFields$find$mes !== void 0 ? _errorFields$find$mes : '';
}

var ActionButtons = function ActionButtons(_ref2) {
  var onSave = _ref2.onSave,
      onCancel = _ref2.onCancel,
      _ref2$primaryButtonVa = _ref2.primaryButtonVariantType,
      primaryButtonVariantType = _ref2$primaryButtonVa === void 0 ? 'save' : _ref2$primaryButtonVa,
      _ref2$primaryButtonTe = _ref2.primaryButtonText,
      primaryButtonText = _ref2$primaryButtonTe === void 0 ? 'Save changes' : _ref2$primaryButtonTe,
      _ref2$showCancelButto = _ref2.showCancelButton,
      showCancelButton = _ref2$showCancelButto === void 0 ? true : _ref2$showCancelButto,
      isLoading = _ref2.isLoading,
      isPrimaryDisabled = _ref2.isPrimaryDisabled;
  var qaClasses = primaryButtonVariantType === 'save' ? 'save-changes' : 'install';
  return (0, _preact.h)("div", {
    className: "panel-buttons-container"
  }, (0, _preact.h)(_Button.default, {
    size: "medium",
    variant: primaryButtonVariantType,
    title: primaryButtonText,
    onClick: function onClick() {
      return onSave();
    },
    className: "qa-".concat(qaClasses),
    isLoading: isLoading,
    disabled: isPrimaryDisabled
  }), showCancelButton ? (0, _preact.h)(_Button.default, {
    size: "medium",
    title: "Cancel",
    onClick: function onClick() {
      return onCancel();
    },
    className: "qa-cancel-".concat(qaClasses)
  }) : null);
};

exports.ActionButtons = ActionButtons;

var ManageInstallationButtons = function ManageInstallationButtons(_ref3) {
  var onClickManage = _ref3.onClickManage,
      onClickUninstall = _ref3.onClickUninstall;
  return (0, _preact.h)("div", {
    className: "panel-buttons-container"
  }, (0, _preact.h)(_Button.default, {
    size: "medium",
    variant: "brand",
    title: "Manage Integration",
    onClick: function onClick() {
      return onClickManage();
    },
    className: "qa-manage-integration"
  }), (0, _preact.h)(_Button.default, {
    size: "medium",
    variant: "warning",
    title: "Uninstall",
    onClick: function onClick() {
      return onClickUninstall();
    },
    className: "integration__button_uninstall qa-integration-uninstall"
  }));
};

exports.ManageInstallationButtons = ManageInstallationButtons;

var ToggleWithLabel = function ToggleWithLabel(_ref4) {
  var isToggleEnabled = _ref4.isToggleEnabled,
      onSettingChanged = _ref4.onSettingChanged,
      label = _ref4.label;
  return (0, _preact.h)("div", {
    className: "panel-body-switch-container"
  }, (0, _preact.h)(_Switcher.default, {
    on: isToggleEnabled,
    customClass: "panel-switch toggle-note-creation-switch",
    label: label,
    labelCustomClass: "panel-switch-label",
    onChange: function onChange() {
      return onSettingChanged(!isToggleEnabled);
    }
  }));
};

exports.ToggleWithLabel = ToggleWithLabel;

var UnsavedChangesModal = function UnsavedChangesModal(_ref5) {
  var showUnsavedChangesModal = _ref5.showUnsavedChangesModal,
      closeModal = _ref5.closeModal,
      resetChanges = _ref5.resetChanges;
  return (0, _preact.h)(_reactModal.default, {
    isOpen: showUnsavedChangesModal,
    onClose: function onClose() {
      return closeModal();
    }
  }, (0, _preact.h)("div", {
    className: "unsaved-changes-modal"
  }, (0, _preact.h)("h3", {
    className: "modal-title"
  }, "Unsaved Changes"), (0, _preact.h)("div", {
    className: "modal-description"
  }, "You have unsaved changes. Do you want to discard them?"), (0, _preact.h)(_Button.default, {
    size: "medium",
    variant: "brand",
    title: "Discard changes",
    onClick: function onClick() {
      return resetChanges();
    }
  }), (0, _preact.h)(_Button.default, {
    size: "medium",
    title: "Cancel",
    onClick: function onClick() {
      return closeModal();
    }
  })));
};

exports.UnsavedChangesModal = UnsavedChangesModal;

var InstallAndUninstallButtons = function InstallAndUninstallButtons(_ref6) {
  var onClickUninstallButton = _ref6.onClickUninstallButton,
      disabled = _ref6.disabled;

  var getSelectorItems = function getSelectorItems() {
    var actions = [{
      isPrincipal: true,
      title: 'Installed',
      titleWithIcon: (0, _preact.h)("div", null, (0, _preact.h)(_assets.default, {
        icon: "checkmark",
        height: 12,
        width: 12
      }), "Installed"),
      class: 'installated__button qa-installed'
    }, {
      title: 'Uninstall',
      onClick: function onClick() {
        return onClickUninstallButton();
      },
      class: 'qa-uninstall',
      disabled: disabled
    }];
    return actions;
  };

  return (0, _preact.h)(_buttonControlSelector.default, {
    newStyle: true,
    variant: "secondary",
    size: "medium",
    iconCloseName: "moreHoriz",
    iconOpenName: "moreHoriz",
    triggerButtonCustomClassName: "installation__button_options",
    items: getSelectorItems(),
    disabled: disabled
  });
};

exports.InstallAndUninstallButtons = InstallAndUninstallButtons;